export default __webpack_public_path__ + "static/media/start_engage.e57a007b.svg";